import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dimensions } from '../Dimensions/Dimensions.js';
import { InventoryNumber } from '../InventoryNumber/InventoryNumber.js';
import styles from './Cartel.module.css';
/**
 * Cartel d'œuvre : artiste, titre, année, technique, dimensions, numéro
 * d'inventaire en mono (2.4, 3.2 — fiche de « Réserve »). Le titre est
 * l'élément dominant — jamais l'inverse : c'est l'œuvre qu'on consulte,
 * pas sa fiche administrative.
 */
export function Cartel({ artist, title, year, medium, dimensions, inventoryNumber, size = 'sm', className, ...rest }) {
    const classes = [styles.cartel, styles[`cartel-${size}`], className].filter(Boolean).join(' ');
    const metaLine = [year, medium].filter(Boolean).join(', ');
    return (_jsxs("figcaption", { className: classes, ...rest, children: [_jsx("span", { className: styles.artist, children: artist }), _jsx("span", { className: styles.title, children: title }), metaLine ? _jsx("span", { className: styles.meta, children: metaLine }) : null, dimensions ? _jsx(Dimensions, { className: styles.dimensions, ...dimensions }) : null, inventoryNumber ? (_jsx(InventoryNumber, { className: styles.inventory, value: inventoryNumber })) : null] }));
}
//# sourceMappingURL=Cartel.js.map